<template>
  <div class="clear-phone-no-dialog">
    <el-dialog style="margin-top: 40px" :visible.sync="isShow" title="明文查看" width="600px" center @close="dialogClose">
      <div slot="title" style="font-weight: 500; font-size: 20px">明文查看</div>
      <el-form style="width: 500px" label-width="100px">
        <el-form-item label="验证方式:">
          <el-radio-group v-model="radio">
            <el-radio :label="1">密码</el-radio>
            <el-radio :label="2">手机号</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="typeFix" label="有效时间:">
          <el-radio-group v-model="timeRadio">
            <el-radio :label="8">4小时</el-radio>
            <el-radio :label="4">2小时</el-radio>
            <el-radio :label="2">1小时</el-radio>
            <el-radio :label="1">30分钟</el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="radio === 2">
          <el-form-item required label="手机号:">
            <el-input v-model="phoneNo" placeholder="请输入手机号" disabled></el-input>
          </el-form-item>
          <el-form-item required label="验证码:">
            <el-input v-model="vercode" placeholder="请输入手机号">
              <el-button slot="append" @click="getVercode" :disabled="countDown > 0">
                {{ countDown === 0 ? "获取验证码" : "倒计时" + countDown + "秒" }}
              </el-button>
            </el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item required label="密码">
            <el-input v-model="password" placeholder="请输入密码" type="password"></el-input>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="dialogCheck">验证</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {checkPassword, checkVerCode, getVerCode2} from "@/api/account-api";
import {addOption} from "@/api/log-api";

export default {
  name: "ClearPhoneNoDialog",
  props: {
    pageName: {type: String,},
    show: {type: Boolean,},
    typeFix: {type: Boolean, default: false},
  },
  data() {
    return {
      isShow: false,
      radio: 1,
      timeRadio: 8,
      password: "",
      phoneNo: "",
      vercode: "",


      countDown: 0,
      timer: null,
      verCodeHasRequest: false,
    }
  },

  watch: {
    show: {
      handler: function (val) {
        if (val) {
          this.radio = 1
          this.password = ""
          this.vercode = ""
          if (this.$store.state.accountType === "manage") {
            this.phoneNo = this.$store.state.loginInfo.telephone
          } else {
            this.phoneNo = this.$store.state.employeeLoginInfo.tel
          }
        }
        this.isShow = val
      },
      immediate: true
    },
  },

  methods: {
    dialogClose() {
      this.$emit('dialogClose', false)
    },

    dialogCheck() {
      if (this.radio === 1) {
        this.checkByPassword()
      } else {
        this.checkByPhoneNo()
      }
    },

    checkByPhoneNo() {
      if (this.vercode === "") {
        this.$message.info('请输入验证码');
        return
      }
      if (!this.verCodeHasRequest) {
        this.$message.info('请先获取验证码');
        return
      }
      let phNo = this.phoneNo
      checkVerCode(phNo, this.vercode).then(({data}) => {
        console.log(" checkVerCode =>", data)
        if (data.code === 200) {
          this.doOnCheckSuccess()
        } else {
          this.doOnCheckFalse()
        }
      }).catch(err => {
        console.log(" checkVerCode =>", err)
        this.doOnCheckFalse()
      })
    },

    checkByPassword() {
      if (this.password === "") {
        this.$message.info('请输入密码');
        return
      }
      // 由后端按当前 token 校验：cookie 缓存的明文在 SSO 免登会话缺失、改密后也不刷新，不可再依赖
      checkPassword(this.password).then(({data}) => {
        if (data.code === 200) {
          this.doOnCheckSuccess()
        } else {
          this.doOnCheckFalse()
        }
      }).catch(err => {
        console.log(" checkPassword =>", err)
        this.doOnCheckFalse()
      })
    },

    doOnCheckSuccess() {
      this.requestLog("明文查看-" + this.pageName)
      this.$message.success("验证通过");
      this.$emit('dialogClose', true, this.timeRadio)

    },

    requestLog(logType) {
      if (this.$store.state.accountType === "manage") {
        this.loginInfo = this.$store.state.loginInfo
      } else {
        this.loginInfo = this.$store.state.employeeLoginInfo
      }
      let accountId = this.loginInfo.id
      let data = {"accountId": accountId, "type": logType, "request": "", "response": ""}
      addOption(data).then(({data}) => {
        console.log("data =>", data)
      }).catch(err => {
        console.log(" checkVerCode =>", err)
      })
    },

    doOnCheckFalse() {
      this.$message.error("验证失败");
    },

    getVercode() {
      if (this.countDown > 0) {
        this.$message.info('验证码已发送');
        return
      }
      this.verCodeHasRequest = true
      getVerCode2(this.phoneNo, "明文查看").then(({data}) => {
        if (data.code === 200) {
          this.resetDialogCountDown()
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(err => {
        console.log(" requestVerCode =>", err)
        this.showNetErrMsg();
      })
    },

    resetDialogCountDown() {
      this.countDown = 60

      if (this.timer != null) {
        clearInterval(this.timer)
        this.timer = null
        this.countDown = 0
      }

      this.timer = setInterval(() => {
        this.countDown--
        if (this.countDown === 0) {
          clearInterval(this.timer)
          this.timer = null
          this.countDown = 0
        }
      }, 1000)
    },
  }
}
</script>

<style scoped lang="less">
.dialog-sign {
  display: flex;
  height: 45vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.el-form-item /deep/ .el-input {
  width: 400px;
}

.el-form-item /deep/ .el-radio-group {
  width: 400px;
}

</style>
